import styled from '@emotion/styled'
import type { FC, PropsWithChildren } from 'react'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface CustomSectionProps {
  overline?: string
  heading?: string
  description?: string
  linkText?: string
  linkUrl?: string
}

const CustomSection: FC<PropsWithChildren<CustomSectionProps>> = ({
  overline,
  heading,
  description,
  linkText,
  linkUrl,
}) => {
  return (
    <Wrapper>
      <SectionBase variant="noCopy">
        <Section.Contents>
          <StyledCopyTextBase centered={true}>
            {overline && <StyledCopyTextOverline variant="h5">{overline}</StyledCopyTextOverline>}
            {heading && (
              <CopyText.Heading tag="h2" variant="h2">
                {heading}
              </CopyText.Heading>
            )}
            {description && (
              <CopyText.Description tag="p" variant="pLarge">
                {description}
              </CopyText.Description>
            )}
            {linkUrl && <CopyText.Link href={linkUrl}>{linkText}</CopyText.Link>}
          </StyledCopyTextBase>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const StyledCopyTextOverline = styled(CopyText.Overline)`
  text-transform: uppercase;
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
  margin: 0 auto;
`

const Wrapper = styled.div``

export default CustomSection
